import { createApp } from 'vue'
import './style.css'
import { createPinia } from 'pinia' // 确保导入Pinia
import router from './router' // 导入路由配置
import App from './App.vue'
import vant from 'vant'
import 'vant/lib/index.css' // 引入 Vant 全局样式
import '@/styles/tabbar.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// 挂载全局 Store
import { useUserStore } from '@/stores/user'

// 埋点插件
import analyticsPlugin from '@/plugins/analytics'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
const app = createApp(App)
app.use(createPinia()) // 必须在router之前安装
app.use(router) // 挂载路由
app.use(vant) // 全局注册 Vant 组件
// 安装埋点插件（自动路由埋点）
app.use(analyticsPlugin, { router, autoTrack: true })
app.mount('#app')


app.config.globalProperties.$userStore = useUserStore()